// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Full-screen blocking gate shown after login when the organization enforces
   Two-Step Verification and this user hasn't set it up yet.

   The backdrop is the login page itself, blurred and inert — a frosted surface
   rather than a flat colour. A light scrim over it keeps the heading and card
   readable; the card stays sharp and interactive on top. */

.enforce2fa-gate {
  position: fixed;
  inset: 0;
  z-index: 1000;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
}

/* the login page, blurred; scaled up a touch so the blur's soft edges never show */
.enforce2fa-backdrop {
  position: fixed;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  pointer-events: none;
  filter: blur(10px) saturate(1.03);
  transform: scale(1.06);
  transform-origin: center;
}

/* light frosted scrim so text stays readable over whatever is behind */
.enforce2fa-scrim {
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  background: rgba(240, 244, 249, 0.58);
}

.enforce2fa-inner {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 620px;
}

.enforce2fa-head {
  text-align: center;
  margin-bottom: 22px;
}

.enforce2fa-emoji {
  font-size: 42px;
  margin-bottom: 10px;
  line-height: 1;
}

.enforce2fa-title {
  font-size: 24px;
  font-weight: 800;
  color: var(--clr-dark);
  font-family: "Sora", var(--font-display, sans-serif);
  letter-spacing: -0.01em;
  margin: 0;
}

.enforce2fa-sub {
  font-size: 14px;
  line-height: 1.6;
  color: var(--clr-text);
  font-weight: 600;
  margin: 10px auto 0;
  max-width: 52ch;
}

/* TwoFactorSettings brings its own card; this wrapper only lifts it off the
   backdrop with a soft shadow. */
.enforce2fa-card {
  border-radius: 14px;
  box-shadow: 0 24px 70px rgba(11, 58, 102, 0.28);
}

.enforce2fa-footer {
  text-align: center;
  margin-top: 20px;
}

.enforce2fa-signout {
  background: var(--clr-surface);
  color: var(--clr-text-light);
  border: 1px solid var(--clr-border);
  border-radius: 10px;
  padding: 9px 22px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(11, 58, 102, 0.12);
  transition: background 0.15s, box-shadow 0.15s;
}

.enforce2fa-signout:hover {
  background: var(--n-50);
  box-shadow: 0 4px 16px rgba(11, 58, 102, 0.18);
}
`, "",{"version":3,"sources":["webpack://./src/components/common/Enforce2FAGate.css"],"names":[],"mappings":"AAAA;;;;;2DAK2D;;AAE3D;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA,mFAAmF;AACnF;EACE,eAAe;EACf,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,oBAAoB;EACpB,iCAAiC;EACjC,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA,uEAAuE;AACvE;EACE,eAAe;EACf,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oDAAoD;EACpD,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;iCACiC;AACjC;EACE,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,mCAAmC;EACnC,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8CAA8C;EAC9C,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;EACvB,8CAA8C;AAChD","sourcesContent":["/* Full-screen blocking gate shown after login when the organization enforces\n   Two-Step Verification and this user hasn't set it up yet.\n\n   The backdrop is the login page itself, blurred and inert — a frosted surface\n   rather than a flat colour. A light scrim over it keeps the heading and card\n   readable; the card stays sharp and interactive on top. */\n\n.enforce2fa-gate {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  overflow: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  box-sizing: border-box;\n}\n\n/* the login page, blurred; scaled up a touch so the blur's soft edges never show */\n.enforce2fa-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 0;\n  overflow: hidden;\n  pointer-events: none;\n  filter: blur(10px) saturate(1.03);\n  transform: scale(1.06);\n  transform-origin: center;\n}\n\n/* light frosted scrim so text stays readable over whatever is behind */\n.enforce2fa-scrim {\n  position: fixed;\n  inset: 0;\n  z-index: 0;\n  pointer-events: none;\n  background: rgba(240, 244, 249, 0.58);\n}\n\n.enforce2fa-inner {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: 620px;\n}\n\n.enforce2fa-head {\n  text-align: center;\n  margin-bottom: 22px;\n}\n\n.enforce2fa-emoji {\n  font-size: 42px;\n  margin-bottom: 10px;\n  line-height: 1;\n}\n\n.enforce2fa-title {\n  font-size: 24px;\n  font-weight: 800;\n  color: var(--clr-dark);\n  font-family: \"Sora\", var(--font-display, sans-serif);\n  letter-spacing: -0.01em;\n  margin: 0;\n}\n\n.enforce2fa-sub {\n  font-size: 14px;\n  line-height: 1.6;\n  color: var(--clr-text);\n  font-weight: 600;\n  margin: 10px auto 0;\n  max-width: 52ch;\n}\n\n/* TwoFactorSettings brings its own card; this wrapper only lifts it off the\n   backdrop with a soft shadow. */\n.enforce2fa-card {\n  border-radius: 14px;\n  box-shadow: 0 24px 70px rgba(11, 58, 102, 0.28);\n}\n\n.enforce2fa-footer {\n  text-align: center;\n  margin-top: 20px;\n}\n\n.enforce2fa-signout {\n  background: var(--clr-surface);\n  color: var(--clr-text-light);\n  border: 1px solid var(--clr-border);\n  border-radius: 10px;\n  padding: 9px 22px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: 0 2px 10px rgba(11, 58, 102, 0.12);\n  transition: background 0.15s, box-shadow 0.15s;\n}\n\n.enforce2fa-signout:hover {\n  background: var(--n-50);\n  box-shadow: 0 4px 16px rgba(11, 58, 102, 0.18);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
